import { timeStampNow, ConsoleApiName, ErrorSource } from '@datadog/browser-core';
import { StatusType } from '../logger/isAuthorized';
import { createErrorFieldFromRawError } from '../createErrorFieldFromRawError';
export const LogStatusForApi = {
    [ConsoleApiName.log]: StatusType.info,
    [ConsoleApiName.debug]: StatusType.debug,
    [ConsoleApiName.info]: StatusType.info,
    [ConsoleApiName.warn]: StatusType.warn,
    [ConsoleApiName.error]: StatusType.error,
};
export function startConsoleCollection(configuration, lifeCycle, bufferedDataObservable) {
    const subscription = bufferedDataObservable.subscribe(({ data: log, type }) => {
        if (type !== 3 /* BufferedDataType.CONSOLE */ || !configuration.forwardConsoleLogs.includes(log.api)) {
            return;
        }
        const collectedData = {
            rawLogsEvent: {
                date: timeStampNow(),
                message: log.message,
                origin: ErrorSource.CONSOLE,
                error: log.error && createErrorFieldFromRawError(log.error),
                status: LogStatusForApi[log.api],
            },
            messageContext: log.error?.context,
            domainContext: {
                handlingStack: log.handlingStack,
            },
        };
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, collectedData);
    });
    return { stop: () => subscription.unsubscribe() };
}
//# sourceMappingURL=consoleCollection.js.map